import Glide, { Autoplay } from '@glidejs/glide/dist/glide.modular.esm';

export default function init() {
  const roots = document.querySelectorAll('.full-size-ad-carousel');

  [...roots].forEach((root) => {
    const timeout = parseInt(root.dataset.timeout, 10);
    const glideRoot = root.querySelector('.glide');

    new Glide(glideRoot, {
      autoplay: timeout || 15000,
      gap: 0,
    }).mount({ Autoplay });
  });
}
